import { memo } from "react";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";

initMercadoPago(process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY, {
  locale: "es-AR",
});

const AttentionSVG = () => <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 8V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8ZM11.29 15.29C11.3834 15.1973 11.4943 15.124 11.6161 15.0742C11.7379 15.0245 11.8684 14.9992 12 15C11.8684 14.9992 11.7379 15.0245 11.6161 15.0742C11.4943 15.124 11.3834 15.1973 11.29 15.29ZM11 16C10.9992 15.8684 11.0245 15.7379 11.0742 15.6161C11.124 15.4943 11.1973 15.3834 11.29 15.29C11.1973 15.3834 11.124 15.4943 11.0742 15.6161C11.0245 15.7379 10.9992 15.8684 11 16ZM12 15C11.8022 15 11.6089 15.0586 11.4444 15.1685C11.28 15.2784 11.1518 15.4346 11.0761 15.6173C11.0004 15.8 10.9806 16.0011 11.0192 16.1951C11.0578 16.3891 11.153 16.5673 11.2929 16.7071C11.4328 16.847 11.6109 16.9422 11.8049 16.9808C11.9989 17.0194 12.2 16.9996 12.3827 16.9239C12.5654 16.8482 12.7216 16.72 12.8315 16.5556C12.9414 16.3911 13 16.1978 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15ZM22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17317C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12ZM20 12C20 10.4177 19.5308 8.87103 18.6518 7.55544C17.7727 6.23984 16.5233 5.21447 15.0615 4.60896C13.5997 4.00346 11.9911 3.84504 10.4393 4.15372C8.88743 4.4624 7.46197 5.22433 6.34315 6.34315C5.22433 7.46197 4.4624 8.88743 4.15372 10.4393C3.84504 11.9911 4.00347 13.5997 4.60897 15.0615C5.21447 16.5233 6.23985 17.7727 7.55544 18.6518C8.87104 19.5308 10.4178 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1572 16.1566 20 14.1217 20 12Z"
      fill="#222221"
    />
  </svg>;

const MercadoPago = (props) => {
  const { order, isExtenalProduct } = props;
  function onSubmit() {
    const preferenceDTO = {
      external_reference: order.payment.public_id,
      // quotation_id: order.booking.quotation.public_id,
      // quotation_title: order.booking.quotation.title,
      // quotation_total: order.booking.quotation.total,
      // passengers_quantity: order.passengers.length,
      // currency_code: order.booking.quotation.currency.code,
    };

    return new Promise((resolve, reject) => {

      const res = isExtenalProduct ? '/mercadopago/create_preference/experience' : '/mercadopago/create_preference';

      fetch(process.env.REACT_APP_API_URL + res, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(preferenceDTO),
      })
        .then((response) => response.json())
        .then((data) => {
          resolve(data.preference_id);
        })
        .catch((error) => {
          reject();
        });
    });
  }

  return (
    <div className="mercadoPago__container">
      {order.booking?.quotation?.currency?.code !== 'ARS' && (
        <div className="note-mp">
          <AttentionSVG/>
          <span>
            El cobro en Mercado Pago se realizará en Pesos Argentinos al tipo de cambio oficial
            más impuestos.
          </span>
        </div>
      )}
      <Wallet onSubmit={() => onSubmit()} />
    </div>
  );
};

export default memo(MercadoPago);
